"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SVGComponent = (props) => (React.createElement("svg", Object.assign({ width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9796 19.9531H19.3997", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M21.8628 22.4146C23.2231 22.4146 24.3259 21.3118 24.3259 19.9514C24.3259 18.5911 23.2231 17.4883 21.8628 17.4883C20.5025 17.4883 19.3997 18.5911 19.3997 19.9514C19.3997 21.3118 20.5025 22.4146 21.8628 22.4146Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M9.51518 22.3678C10.8755 22.3678 11.9783 21.265 11.9783 19.9046C11.9783 18.5442 10.8755 17.4414 9.51518 17.4414C8.15484 17.4414 7.05206 18.5442 7.05206 19.9046C7.05206 21.265 8.15484 22.3678 9.51518 22.3678Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M6.62496 19.9524H5.66111C5.32997 19.9512 5.01063 19.8294 4.76282 19.6098C4.51501 19.3901 4.35574 19.0877 4.31481 18.7591L4.00881 15.7911C3.96946 15.4493 4.0567 15.1049 4.25402 14.823C4.45135 14.5411 4.74511 14.3412 5.07977 14.2612L5.98241 14.047C6.3972 13.9424 6.76083 13.6928 7.00744 13.3433L8.85864 10.7272C9.1596 10.2965 9.56024 9.94493 10.0264 9.70251C10.4926 9.4601 11.0105 9.33399 11.536 9.33498H16.1257C16.7491 9.3332 17.3663 9.45845 17.9398 9.70307C18.5132 9.94769 19.0307 10.3065 19.4609 10.7578L22.5207 14.0011L26.4067 14.7049C26.6696 14.7531 26.9197 14.8549 27.1415 15.0042C27.3632 15.1534 27.5518 15.3468 27.6954 15.5722C27.839 15.7977 27.9345 16.0503 27.976 16.3144C28.0175 16.5784 28.0041 16.8482 27.9366 17.1068L27.5694 18.6367C27.4705 19.0234 27.2451 19.3661 26.929 19.61C26.613 19.8539 26.2245 19.9852 25.8253 19.983H24.2036", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M22.5358 14.0169L6.42584 13.8945", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 })));
exports.default = SVGComponent;
//# sourceMappingURL=right-arrow.js.map